import isPublicView from "app/utils/publicViewUtils";
import { useRef } from "react";
import { FormattedMessage } from "react-intl";
import "../../BetDrawerScreen.scss";
import "../BetSlipLists/components/MultiplesBetSlipList/MultiplesBetSlipList.scss";
import "./Stake.scss";

type Props = {
  stake: number | null;
  setStake: (value: number | null) => void;
};

export const Stake: React.FC<Props> = ({ stake, setStake }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const handleStakeInput = ev => {
    const value = ev.target.value;
    setStake(value === "" ? null : parseFloat(value));
  };

  return (
    <div className="stake-container">
      <div className={`stake-container__input-stake`}>
        <label className="stake-container__input-stake__container">
          <span className="stake-container__input-stake__label">
            <FormattedMessage tagName="span" id="reports-stake" />
          </span>
          <input
            type="number"
            pattern="[0-9]*"
            min={0}
            ref={inputRef}
            className="stake-container__input-stake__input"
            //To maintain this as a controlled input, need to set the value in state as a number and in the input as a string
            value={stake !== null ? stake.toString() : ""}
            onChange={handleStakeInput}
            placeholder={"0"}
            onWheel={e => {
              inputRef?.current?.blur();
            }}
            onKeyDown={event => {
              if (isPublicView() && event.key === "Enter") {
                event.preventDefault();
              }
            }}
          />
        </label>
      </div>
    </div>
  );
};
